"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "provider-options font-xsm"
};
const _hoisted_2 = { class: "d-flex flex-wrap flex-gap" };
const _hoisted_3 = ["value", "disabled"];
const _hoisted_4 = {
    key: 0,
    class: "selected-file"
};
const _hoisted_5 = { class: "selected-file-name font-xsm" };
const _hoisted_6 = { class: "input-row" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    key: 1,
    class: "voice-input-error text-error font-xsm"
};
const vue_3 = require("vue");
const PaperPlaneIcon_vue_1 = __importDefault(require("../../../vue/icons/PaperPlaneIcon.vue"));
const provider_1 = require("../../../provider/provider");
const autoAIAgentRequest_1 = require("../../../requests/autoAIAgentRequest");
const summary_lib_1 = require("../../../js/summary_lib");
const errors_1 = __importDefault(require("../../../js/errors"));
const autoAIAgent_1 = require("./autoAIAgent");
const AutoAIAgentMessages_vue_1 = __importDefault(require("./AutoAIAgentMessages.vue"));
const autoAIStorage_1 = require("../../../storage/autoAIStorage");
const VoiceToTextButton_vue_1 = __importDefault(require("../voiceToText/VoiceToTextButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIAgentChat',
    emits: ["use-prompt"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const draft = (0, vue_3.ref)('');
        const viewModel = (0, vue_3.inject)(provider_1.autoAIAgentViewModelInjectKey);
        const messageInput = (0, vue_3.ref)(null);
        const fileInput = (0, vue_3.ref)(null);
        const selectedFile = (0, vue_3.ref)(null);
        const provider = (0, vue_3.ref)(autoAIAgent_1.defaultAutoAIAgentProvider);
        const historyMessages = (0, vue_3.ref)([]);
        const isLoadingHistory = (0, vue_3.ref)(false);
        const isSending = (0, vue_3.ref)(false);
        const pendingMessage = (0, vue_3.ref)(null);
        const latestAgentPrompt = (0, vue_3.ref)('');
        const showNextStepActions = (0, vue_3.ref)(false);
        const voiceErrorMessage = (0, vue_3.ref)('');
        const isVoiceInputActive = (0, vue_3.ref)(false);
        const requestAbortController = new AbortController();
        const canSend = (0, vue_3.computed)(() => {
            return !isSending.value && !isVoiceInputActive.value && (draft.value.trim().length > 0 || selectedFile.value !== null);
        });
        const showReplyStatus = (0, vue_3.computed)(() => {
            return isSending.value && pendingMessage.value !== null;
        });
        const showProviderOptions = (0, vue_3.computed)(() => {
            // Hide provider options while the chat is ongoing, to avoid changing the provider mid-conversation
            return historyMessages.value.length === 0 && pendingMessage.value === null;
        });
        function openFilePicker() {
            fileInput.value?.click();
        }
        function handleFileChange(event) {
            const input = event.target;
            selectedFile.value = input.files?.[0] ?? null;
        }
        function removeSelectedFile() {
            selectedFile.value = null;
            if (fileInput.value) {
                fileInput.value.value = '';
            }
        }
        function resizeMessageInput() {
            if (!messageInput.value) {
                return;
            }
            messageInput.value.style.height = 'auto';
            messageInput.value.style.height = `${Math.min(messageInput.value.scrollHeight, 120)}px`;
        }
        function appendVoiceTranscript(text) {
            const current = draft.value.trimEnd();
            draft.value = current ? `${current}\n${text}` : text;
            (0, vue_3.nextTick)(() => {
                resizeMessageInput();
                messageInput.value?.focus();
            });
        }
        function setVoiceErrorMessage(message) {
            voiceErrorMessage.value = message;
        }
        function setVoiceInputActive(isActive) {
            isVoiceInputActive.value = isActive;
        }
        function messageToPrompt(message) {
            if (!message) {
                return '';
            }
            if (message.Message) {
                const parsedDocument = new DOMParser().parseFromString(message.Message, 'text/html');
                const recommendedPromptHeadings = new Set(['推奨プロンプト', 'Recommended prompt']);
                const recommendedPromptHeading = Array.from(parsedDocument.querySelectorAll('h2')).find(heading => recommendedPromptHeadings.has(heading.textContent?.trim() ?? ''));
                let sectionElement = recommendedPromptHeading?.nextElementSibling;
                while (sectionElement && !/^H[1-6]$/.test(sectionElement.tagName)) {
                    if (sectionElement.tagName === 'PRE') {
                        const prompt = sectionElement.querySelector('code')?.textContent?.trim();
                        if (prompt) {
                            return prompt;
                        }
                    }
                    sectionElement = sectionElement.nextElementSibling;
                }
            }
            if (message.MessageRaw) {
                return message.MessageRaw.trim();
            }
            const parsedDocument = new DOMParser().parseFromString(message.Message, 'text/html');
            return (parsedDocument.body.innerText || parsedDocument.body.textContent || '').trim();
        }
        function usePrompt() {
            if (latestAgentPrompt.value) {
                emit('use-prompt', {
                    prompt: latestAgentPrompt.value,
                    provider: provider.value,
                });
            }
        }
        function modifyPrompt() {
            showNextStepActions.value = false;
            (0, vue_3.nextTick)(() => messageInput.value?.focus());
        }
        function getChatContext() {
            const vm = viewModel?.value;
            const chatId = vm?.currentAgent?.ID;
            if (!vm || !chatId) {
                return;
            }
            return {
                groupId: vm.groupId,
                branchId: vm.branchId,
                userId: vm.userId,
                chatId,
            };
        }
        async function waitForReply() {
            const context = getChatContext();
            if (!context) {
                throw new Error('No selected shift agent');
            }
            while (!requestAbortController.signal.aborted) {
                const current = await (0, autoAIAgentRequest_1.getAutoAIAgentCurrentMessageRequest)(context.branchId, context.userId, context.chatId, requestAbortController.signal);
                if (current.timeout) {
                    continue;
                }
                if (current.errorhappened) {
                    throw new Error(current.errortext || 'Shift agent failed to answer');
                }
                return;
            }
        }
        async function loadChatHistory(waitForPendingAnswer = true) {
            const context = getChatContext();
            if (!context) {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.LOAD);
                return;
            }
            isLoadingHistory.value = true;
            try {
                const history = await (0, autoAIAgentRequest_1.getAutoAIAgentChatRequest)(context.branchId, context.userId, context.chatId, requestAbortController.signal);
                historyMessages.value = Array.isArray(history.messages) ? history.messages : [];
                const lastMessage = historyMessages.value[historyMessages.value.length - 1];
                if (history.waitingAnswer || !lastMessage?.isAgent) {
                    latestAgentPrompt.value = '';
                    showNextStepActions.value = false;
                }
                else {
                    latestAgentPrompt.value = messageToPrompt(lastMessage);
                    showNextStepActions.value = latestAgentPrompt.value.length > 0;
                }
                if (waitForPendingAnswer && history.waitingAnswer) {
                    isSending.value = true;
                    await waitForReply();
                    await loadChatHistory(false);
                }
            }
            catch {
                if (!requestAbortController.signal.aborted) {
                    (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.LOAD);
                }
            }
            finally {
                isLoadingHistory.value = false;
                isSending.value = false;
            }
        }
        async function sendMessage() {
            if (!canSend.value) {
                return;
            }
            const context = getChatContext();
            if (!context) {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.SEND);
                return;
            }
            const messageText = draft.value.trim();
            const messageFile = selectedFile.value ?? undefined;
            showNextStepActions.value = false;
            pendingMessage.value = {
                text: messageText,
                fileName: messageFile?.name,
            };
            draft.value = '';
            removeSelectedFile();
            (0, vue_3.nextTick)(resizeMessageInput);
            isSending.value = true;
            try {
                const sentMessage = await (0, autoAIAgentRequest_1.sendAutoAIAgentMessageRequest)({
                    branchId: context.branchId,
                    userId: context.userId,
                    chatId: context.chatId,
                    message: messageText,
                    provider: provider.value,
                    file: messageFile,
                    signal: requestAbortController.signal,
                });
                pendingMessage.value = {
                    text: messageText,
                    fileName: messageFile?.name,
                    Message: sentMessage.Message,
                    MessageRaw: sentMessage.MessageRaw,
                };
                (0, autoAIStorage_1.saveAutoAIAgentProvider)(context.userId, context.groupId, context.chatId, provider.value);
            }
            catch {
                pendingMessage.value = null;
                draft.value = messageText;
                selectedFile.value = messageFile ?? null;
                if (!requestAbortController.signal.aborted) {
                    (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.SEND);
                }
                isSending.value = false;
                return;
            }
            try {
                await waitForReply();
                await loadChatHistory(false);
                pendingMessage.value = null;
            }
            catch {
                if (!requestAbortController.signal.aborted) {
                    (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.REPLY);
                }
            }
            finally {
                isSending.value = false;
            }
        }
        (0, vue_3.onMounted)(() => {
            const context = getChatContext();
            if (context) {
                provider.value = (0, autoAIStorage_1.getAutoAIAgentProvider)(context.userId, context.groupId, context.chatId);
            }
            loadChatHistory();
        });
        (0, vue_3.onBeforeUnmount)(() => requestAbortController.abort());
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["agent-chat", { 'loading': isLoadingHistory.value }])
            }, [
                (0, vue_2.createVNode)(AutoAIAgentMessages_vue_1.default, {
                    "history-messages": historyMessages.value,
                    "pending-message": pendingMessage.value,
                    "show-reply-status": showReplyStatus.value,
                    "show-next-step-actions": showNextStepActions.value,
                    onUsePrompt: usePrompt,
                    onModifyPrompt: modifyPrompt
                }, null, 8 /* PROPS */, ["history-messages", "pending-message", "show-reply-status", "show-next-step-actions"]),
                (showProviderOptions.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", null, "提供元:", -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(autoAIAgent_1.autoAIAgentProviderOptions), (option) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                    key: option,
                                    class: "oplus-form-radio"
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((provider).value = $event)),
                                        value: option,
                                        type: "radio",
                                        disabled: isSending.value
                                    }, null, 8 /* PROPS */, _hoisted_3), [
                                        [vue_2.vModelRadio, provider.value]
                                    ]),
                                    _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(option), 1 /* TEXT */)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("form", {
                    class: "message-form",
                    onSubmit: (0, vue_2.withModifiers)(sendMessage, ["prevent"])
                }, [
                    (selectedFile.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(selectedFile.value.name), 1 /* TEXT */),
                            (0, vue_2.createElementVNode)("button", {
                                type: "button",
                                class: "remove-file-button",
                                "aria-label": "Remove selected file",
                                onClick: removeSelectedFile
                            }, [...(_cache[4] || (_cache[4] = [
                                    (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close" }, null, -1 /* CACHED */)
                                ]))])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                            ref_key: "messageInput",
                            ref: messageInput,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((draft).value = $event)),
                            class: "message-input",
                            rows: "1",
                            placeholder: "メッセージを入力...",
                            "aria-label": "Chat message",
                            disabled: isSending.value,
                            onInput: resizeMessageInput
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
                            [vue_2.vModelText, draft.value]
                        ]),
                        (0, vue_2.createElementVNode)("input", {
                            ref_key: "fileInput",
                            ref: fileInput,
                            class: "file-input",
                            type: "file",
                            accept: ".csv,.xls,.xlsx,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            onChange: handleFileChange
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "attachment-button",
                            "aria-label": "Attach a file",
                            disabled: isSending.value,
                            onClick: openFilePicker
                        }, [...(_cache[5] || (_cache[5] = [
                                (0, vue_2.createElementVNode)("i", { class: "icon icon-link" }, null, -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_8),
                        ((0, vue_2.unref)(viewModel))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(VoiceToTextButton_vue_1.default, {
                                key: 0,
                                class: "agent-voice-input",
                                "user-id": (0, vue_2.unref)(viewModel).userId,
                                disabled: isSending.value,
                                onTranscript: appendVoiceTranscript,
                                onErrorMessage: setVoiceErrorMessage,
                                onActiveChange: setVoiceInputActive
                            }, null, 8 /* PROPS */, ["user-id", "disabled"]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("button", {
                            type: "submit",
                            class: (0, vue_2.normalizeClass)(["send-button", { 'pointer-event-none': !canSend.value }]),
                            disabled: !canSend.value
                        }, [
                            (0, vue_2.createVNode)(PaperPlaneIcon_vue_1.default, { class: "send-icon" })
                        ], 10 /* CLASS, PROPS */, _hoisted_9)
                    ])
                ], 32 /* NEED_HYDRATION */),
                (voiceErrorMessage.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, (0, vue_2.toDisplayString)(voiceErrorMessage.value), 1 /* TEXT */))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
